import { Navigate } from 'react-router-dom';
export default function PortfolioMahaney() {
  return <Navigate to="/" replace />;
}
